// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.15 1H17.85V4.59026L20 9.49026V23H4V9.49026L6.15 4.59026V1ZM18 9.90974L16.9322 7.47622L16.05 9.87786V21H18V9.90974ZM7.80325 5.8L6.5308 8.7H14.352L15.4173 5.8H7.80325ZM8.15 3V3.8H15.85V3H8.15ZM13 13H11.5743L9.9984 14.5838L8.41536 13H7V19H9V16.4141L10.0016 17.4162L11 16.4127V19H13V13Z"}}]};

const MilkFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'milk-filled',
    ref,
    icon: element,
  },
));

MilkFilledIcon.displayName = 'MilkFilledIcon';

export default MilkFilledIcon;
